/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Package, Package$inboundSchema } from "./package.js";

export type CreatePackageResult = {
  package: Package;
};

/** @internal */
export const CreatePackageResult$inboundSchema: z.ZodMiniType<
  CreatePackageResult,
  unknown
> = z.object({
  package: Package$inboundSchema,
});

export function createPackageResultFromJSON(
  jsonString: string,
): SafeParseResult<CreatePackageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreatePackageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreatePackageResult' from JSON`,
  );
}
